<template>
    <div class="invalid-input">
        {{message}}
    </div>
</template>

<script>
  export default {
    props: {
      vuelidator: {},
      validator: {},
      serverMessage: '',
    },
    computed: {
      message() {
        if (this.serverMessage) {
          return this.serverMessage;
        }
        if (this.validator && this.validator.customErrorMessage && this.validator.customErrorMessage.length > 0) {
            return this.validator.customErrorMessage;
        }
        if (this.vuelidator) {
            if (this.vuelidator.value.required === false) {
              return 'Field is required';
            }
            if (this.vuelidator.value.minLength === false) {
              return `Field must have at least ${this.vuelidator.value.$params.minLength.min} characters`;
            }
            if (this.vuelidator.value.maxLength === false) {
              return `Field cannot exceed ${this.vuelidator.value.$params.maxLength.max} characters`;
            }
            if (this.vuelidator.value.url === false) {
              return `Valid URL's start with either http:// or https://`;
            }
        }
        return 'Please double check your input.';
      },
    },
  };
</script>

<style>
    .invalid-input {
        width: 100%;
        margin-top: .25rem;
        font-size: 80%;
        color: #db3545;
    }
</style>
